
import Loader from '@marketplace/components/shared/loaders/loader.vue'
import { CONVERSATION_CREATE } from '@marketplace/graphql/conversations.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'
import axios from 'axios'
import debounce from 'lodash/debounce'

export default {
    name: 'ModalInboxNewMessage',

    components: {
        Loader,
    },

    data() {
        return {
            query: '',
            isLoading: false,
            suggestions: [],
            url: '',
        }
    },

    mounted() {
        this.$refs.query.focus()
    },

    methods: {
        handleSearch: debounce(function (e) {
            if (e.keyCode === 13 && this.suggestions.length > 0) {
                this.startConversation(this.suggestions[0].url)
                return
            }

            if (this.query.length < 2) {
                this.suggestions = []
                return
            }

            this.isLoading = true

            axios({
                method: 'get',
                'content-type': 'application/json',
                accept: 'application/json',
                url: this.localeUrl(
                    '/api/internal/autocomplete?query=' + escape(this.query)
                ),
            })
                .then((response) => {
                    this.suggestions =
                        response.data.storefront_search_suggestions
                })
                .finally(() => {
                    this.isLoading = false
                })
        }, 200),

        startConversation: function (url) {
            this.suggestions = []
            this.url = url

            this.isLoading = true

            this.$apollo
                .mutate({
                    mutation: CONVERSATION_CREATE,
                    variables: { url },
                })
                .then((data) => {
                    this.isLoading = false

                    const id = data?.data?.conversationCreate?.conversation?.id

                    if (id) {
                        this.closeModal()
                        this.$router.push(
                            this.localePath({
                                name: 'account-inbox-id',
                                params: { id },
                            })
                        )
                    }
                })
        },

        closeModal() {
            EventBus.$emit('modal-close')
        },
    },
}
